function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 402.154,
    height: 358.916,
    viewBox: "0 0 106.403 94.963",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.99495 0 0 .99425 -52.685 -75.038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m111.937 75.935.005.005c-6.242 0-11.953 1.053-17.131 3.155-5.178 2.033-9.647 4.94-13.406 8.726-.39.4-.767.81-1.14 1.226l.01-.077-27.094 27.864 16.441-.277c-.01.477-.033.953-.033 1.437 0 6.169 1.03 11.81 3.087 16.928 1.455 3.497 3.281 6.676 5.464 9.551l-7.157 6.698c-1.066 1.03-1.605 2.186-1.62 3.474-.011 1.29.496 2.46 1.536 3.513.99 1.003 2.162 1.54 3.515 1.604 1.305.01 2.49-.49 3.555-1.518l7.15-6.692a39.37 39.37 0 0 0 2.58 1.853l-3.364 3.444c-1.066 1.028-1.605 2.185-1.621 3.474-.01 1.289.497 2.459 1.537 3.512.99 1.004 2.162 1.539 3.515 1.605 1.305.01 2.491-.49 3.557-1.519l6.033-5.92c1.25.4 2.53.746 3.838 1.033l-3.394 3.273c-1.066 1.029-1.606 2.188-1.621 3.477-.011 1.288.496 2.459 1.536 3.512.99 1.003 2.162 1.537 3.516 1.602 1.304.01 2.488-.49 3.554-1.518l9.434-9.098-.165-.166c5.357-.209 10.327-1.21 14.907-3.008 5.178-2.103 9.646-5.045 13.406-8.83 3.759-3.786 6.668-8.239 8.726-13.356 2.127-5.117 3.19-10.76 3.19-16.928 0-3.118-.28-6.105-.838-8.967l6.14-21.574-20.422-2.505c-3.024-2.418-6.422-4.373-10.202-5.857-5.18-2.103-10.853-3.156-17.024-3.156z",
    style: {
      fontSize: "25.4px",
      fontFamily: "&quot",
      InkscapeFontSpecification: "&quot",
      letterSpacing: "-1.66423px",
      fill: "#ff61b6",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.928 86.957c-4.546 0-8.715.797-12.515 2.387-3.799 1.525-7.094 3.709-9.876 6.56-2.784 2.85-4.951 6.163-6.512 9.941-1.56 3.779-2.344 7.889-2.344 12.331 0 4.44.784 8.586 2.344 12.43 1.56 3.777 3.73 7.092 6.512 9.942 2.782 2.783 6.077 4.968 9.876 6.56 3.8 1.59 7.969 2.386 12.515 2.386s8.72-.796 12.52-2.387c3.799-1.591 7.09-3.776 9.871-6.56a29.33 28.995 0 0 0 6.516-9.941c1.561-3.845 2.339-7.99 2.339-12.431 0-4.441-.778-8.551-2.339-12.33a29.322 28.986 0 0 0-6.516-9.941c-2.782-2.851-6.072-5.035-9.872-6.56-3.799-1.59-7.973-2.387-12.519-2.387z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 6,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.878,
    cy: 113.867,
    rx: 13.795,
    ry: 13.642,
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 6,
      strokeOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1aa9d976d5afd8f01a594622d06ce875.svg";
export { ForwardRef as ReactComponent };